var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0078125,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3624 9.14689C18.409 9.19334 18.446 9.24851 18.4712 9.30926C18.4964 9.37001 18.5093 9.43513 18.5093 9.50089C18.5093 9.56666 18.4964 9.63178 18.4712 9.69253C18.446 9.75327 18.409 9.80845 18.3624 9.85489L11.3624 16.8549C11.316 16.9015 11.2608 16.9384 11.2001 16.9636C11.1393 16.9888 11.0742 17.0018 11.0084 17.0018C10.9427 17.0018 10.8776 16.9888 10.8168 16.9636C10.7561 16.9384 10.7009 16.9015 10.6544 16.8549L7.15444 13.3549C7.06056 13.261 7.00781 13.1337 7.00781 13.0009C7.00781 12.8681 7.06056 12.7408 7.15444 12.6469C7.24833 12.553 7.37567 12.5003 7.50844 12.5003C7.64122 12.5003 7.76856 12.553 7.86244 12.6469L11.0084 15.7939L17.6544 9.14689C17.7009 9.10033 17.7561 9.06339 17.8168 9.03818C17.8776 9.01297 17.9427 9 18.0084 9C18.0742 9 18.1393 9.01297 18.2001 9.03818C18.2608 9.06339 18.316 9.10033 18.3624 9.14689Z",
    fill: "#1B2635"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.0078125,
    y1: 12.5,
    x2: 25.0078,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FEAFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckActive);
export default __webpack_public_path__ + "static/media/Check Active.380a3c9d.svg";
export { ForwardRef as ReactComponent };